
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "CardText",

    props: {
      classes: {
        type: String,
        required: false,
        default: "title",
      },

      source: {
        type: String,
        required: true,
      },
    },
  });
